<template>
  <vs-card>
    <div style="padding-left: 20px;">
    <h4 class="mb-6 mt-2">Page Details</h4>
    <vs-form>
      <vs-label class="label mt-2">Page Title</vs-label>
      <vs-input class="col-sm-3 mb-6" v-model="pages.title"></vs-input>
      <vs-label class="label mt-2">Slug</vs-label>
      <vs-input class="col-sm-3 mb-6" v-model="pages.slug"></vs-input>
    </vs-form>
    <vs-label class="label">Page Content</vs-label>
    <quillEditor :pages="pages"></quillEditor><br>
    <div slot="footer" class="mb-12 mt-12">
      <vs-row>
        <vs-button @click="savePageDetails" align="left">Save Details</vs-button>
      </vs-row>
    </div>
    </div>
  </vs-card>
</template>

<script>

  import { mapActions } from 'vuex';
  import quillEditor from '../../Editor';

  export default {
    name: 'pageViewEditDetail',
    components: {
      quillEditor,
    },
    data:()=>({
      pages:{
        content:'',
        title:'',
        slug: '',
      },

    }),
    methods:{
      ...mapActions('page', ['fetchPageDetails','updatePageDetails']),
      getPageDetail(id) {
        this.fetchPageDetails(id).then(res => {
          this.pages.content = res.data.data.content;
          this.pages.title= res.data.data.title;
          this.pages.slug = res.data.data.slug;
        });
      },
      savePageDetails(){
        let id = this.$route.params.id;
        let info = this.pages;
        this.updatePageDetails({id,info}).then(res => {
          this.$vs.notify({
            title: 'Update Page Content',
            text: res.data.message,
            color: 'success',
          });
        });
      },
    },
    created() {
      let pageId = this.$route.params.id;
      this.getPageDetail(pageId);
    },
  };
</script>
<style>
  .ql-editor{
    min-height:200px;
  }
  .label {
    font-size: small;
    color: black;
  }
</style>
